import React, { isValidElement, useState } from 'react';
import { Modal, ModalProps, TransitionablePortal } from 'semantic-ui-react';

type OK = () => void | Promise<void>;
type Cancel = () => void;

type Props = {
  title?: React.ReactNode;
  content?: {} | ((close: Function) => React.ReactNode);
  action?: React.ReactNode | ((onOK: OK, onCancel: Cancel) => React.ReactNode);
  trigger?: React.ReactNode;
  size?: ModalProps['size'];
  visible?: boolean;
  onClose?: (value?: any) => void;
};

const CustomModal: React.FC<Props> = ({
  title,
  size = 'tiny',
  content,
  action,
  trigger,
  visible,
  onClose,
}) => {
  const [open, setOpen] = useState<boolean>(false);
  const elementTrigger = isValidElement(trigger) ? trigger : <div />;

  const triggerWithClick = React.cloneElement(elementTrigger, {
    onClick: (e) => {
      // @ts-ignore
      trigger?.props?.onClick?.(e);
      setOpen(true);
    },
  });

  return (
    <React.Fragment>
      <TransitionablePortal
        open={visible || open}
        transition={{ animation: 'scale', duration: 200 }}
      >
        <Modal
          open
          closeIcon
          closeOnEscape
          closeOnDimmerClick
          size={size}
          onClose={() => {
            if (onClose) {
              onClose(undefined);
              return;
            }
            setOpen(false);
          }}
        >
          {title && <Modal.Header>{title}</Modal.Header>}
          {content && typeof content === 'function' ? (
            <Modal.Content>
              {content(() => {
                if (onClose) {
                  onClose(undefined);
                  return;
                }
                setOpen(false);
              })}
            </Modal.Content>
          ) : (
            <Modal.Content>{content}</Modal.Content>
          )}
        </Modal>
      </TransitionablePortal>
      {triggerWithClick}
    </React.Fragment>
  );
};

export default CustomModal;
